module.exports = __webpack_public_path__ + "img/pz7.png";